// ConsultationFeedback/ConsultationFeedbackItem.tsx
import React from 'react';
import {useTheme} from 'Theme/ThemeContext';
import {IConsultationFeedback} from "../../Types/psychology/consultation";
import {FC, FR, FRB} from "WideLayout/Layouts";
import StarRating from "Core/components/StarRating";
import UserAvatar from "User/UserAvatar";


interface ConsultationFeedbackItemProps {
    feedback: IConsultationFeedback;
}

const ConsultationFeedbackItem: React.FC<ConsultationFeedbackItemProps> = ({feedback}) => {
    const {plt} = useTheme();
    return (
        <FC border={`1px solid ${plt.text.primary10}`}
            rounded={3} p={1} gap={1}>
            <FRB>
                <FR gap={1}>
                    {typeof feedback.user !== 'number' &&
                        <UserAvatar avatar={feedback.user ? feedback.user.avatar : undefined} size={'50px'}/>
                    }
                    <FC>
                        {feedback.fake && <span className={'lh-1 mt-1px'}>
                            {feedback.fake.manual_name}
                        </span>}
                        {feedback.user != null && typeof feedback.user !== 'number' &&
                            <span className={'lh-1 mt-1px'}>
                            {feedback.user.first_name} {feedback.user.last_name}
                        </span>
                        }
                        <StarRating rating={feedback.rating_consultation}
                                    starClassName={'fs-5'}
                                    ratingWrapperClassName={'w-min lh-1'}
                                    ratingContentClassName={`bg-transparent frcc lh-1 rounded-2`}
                                    ratingValueStyle={{
                                        color: plt.text.primary80,
                                        marginTop: '4px',
                                        marginRight: '5px',
                                        lineHeight: '1rem',
                                    }}/>
                    </FC>
                </FR>
                <FR lh={'1rem'} color={plt.text.primary60}>
                    {new Date(feedback.created_at).toLocaleDateString('ru-RU')}
                </FR>
            </FRB>
            {feedback.feedback_consultation && <FR>
                {feedback.feedback_consultation}
            </FR>}
        </FC>
    );
};

export default ConsultationFeedbackItem;
